import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_2 = { class: "loading-background" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "loading-content" };
const _hoisted_5 = { class: "loading-title" };
const _hoisted_6 = { class: "progress-container" };
const _hoisted_7 = { class: "progress-bar" };
const _hoisted_8 = { class: "progress-text" };
const _hoisted_9 = { class: "loading-text" };
const _hoisted_10 = {
    key: 0,
    class: "loading-hint"
};
const _hoisted_11 = { class: "loading-decorations" };
import { useImageResource } from '@/IsekaiRPG/shared/composables/useImageResource';
import { computed, onMounted, onUnmounted, ref } from 'vue';
// 导入 R2 资源
import { r2Resources } from '@/IsekaiRPG/resources/r2Resources';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingOverlay',
    props: {
        visible: { type: Boolean },
        title: { default: '正在加载...' },
        progress: { default: 0 },
        text: { default: () => [] },
        hint: { default: '' },
        backgroundImage: { default: '' },
        textChangeInterval: { default: 3000 }
    },
    setup(__props) {
        const defaultLoadingTexts = [
            '在遥远的异世界大陆上，传说中的勇者正在觉醒...',
            '古老的魔法正在苏醒，龙之气息开始在大陆上弥漫...',
            '诸神遗留在人间的宝物，正等待着有缘人的发现...',
            '穿越时空的裂隙正在开启，一个全新的冒险即将开始...',
            '魔法森林的精灵们正在低语，预言着伟大冒险的来临...',
            '古老的预言石碑上，刻满了关于勇者的传说...',
            '在迷雾笼罩的山脉中，沉睡着远古的神秘力量...',
            '星辰指引的道路将引领你前往荣耀的殿堂...',
        ];
        // Props 定义
        const props = __props;
        // 处理背景图片（如果 props 未提供，使用默认背景）
        const targetBackgroundImage = computed(() => {
            return props.backgroundImage || r2Resources.pictures.welcomeBackground;
        });
        // 使用资源加载器加载背景图片
        const { url: backgroundUrl } = useImageResource(targetBackgroundImage.value);
        // 响应式数据
        const currentTextIndex = ref(0);
        const textChangeTimer = ref(null);
        // 计算属性
        const textArray = computed(() => {
            if (Array.isArray(props.text)) {
                return props.text.length > 0 ? props.text : defaultLoadingTexts;
            }
            return props.text ? [props.text] : defaultLoadingTexts;
        });
        const currentTextLines = computed(() => {
            if (textArray.value.length === 0) {
                return ['准备开始您的冒险旅程...'];
            }
            if (textArray.value.length === 1) {
                return textArray.value;
            }
            // 多行文本时，每次显示一行
            return [textArray.value[currentTextIndex.value % textArray.value.length]];
        });
        // 获取粒子样式
        const getParticleStyle = (index) => {
            const angle = (index / 8) * Math.PI * 2;
            const radius = 150;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;
            const delay = index * 0.2;
            return {
                '--x': `${x}px`,
                '--y': `${y}px`,
                '--delay': `${delay}s`,
            };
        };
        // 生命周期钩子
        onMounted(() => {
            if (textArray.value.length > 1) {
                // 多行文本时启动自动切换
                textChangeTimer.value = window.setInterval(() => {
                    currentTextIndex.value = (currentTextIndex.value + 1) % textArray.value.length;
                }, props.textChangeInterval);
            }
        });
        onUnmounted(() => {
            if (textChangeTimer.value) {
                window.clearInterval(textChangeTimer.value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: ".isekai-rpg-container" }, [
                _createVNode(_Transition, {
                    name: "loading-overlay",
                    appear: ""
                }, {
                    default: _withCtx(() => [
                        (__props.visible)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createCommentVNode(" 背景层 "),
                                _createElementVNode("div", _hoisted_2, [
                                    (_unref(backgroundUrl))
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _unref(backgroundUrl),
                                            class: "background-image",
                                            alt: "加载背景"
                                        }, null, 8 /* PROPS */, _hoisted_3))
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" 背景渐变遮罩 "),
                                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "background-overlay" }, null, -1 /* CACHED */))
                                ]),
                                _createCommentVNode(" 主要内容区域 "),
                                _createElementVNode("div", _hoisted_4, [
                                    _createCommentVNode(" 加载图标 "),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loading-icon" }, [
                                        _createElementVNode("div", { class: "magic-circle" }, [
                                            _createElementVNode("div", { class: "circle-ring" }),
                                            _createElementVNode("div", { class: "circle-core" })
                                        ])
                                    ], -1 /* CACHED */)),
                                    _createCommentVNode(" 标题 "),
                                    _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.title), 1 /* TEXT */),
                                    _createCommentVNode(" 进度条 "),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", {
                                                class: "progress-fill",
                                                style: _normalizeStyle({ width: __props.progress + '%' })
                                            }, null, 4 /* STYLE */)
                                        ]),
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(Math.round(__props.progress)) + "%", 1 /* TEXT */)
                                    ]),
                                    _createCommentVNode(" 信息文本 "),
                                    _createElementVNode("div", _hoisted_9, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTextLines.value, (textLine, index) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                                key: index,
                                                class: _normalizeClass(["text-line", { 'fade-in': index === currentTextLines.value.length - 1 }])
                                            }, _toDisplayString(textLine), 3 /* TEXT, CLASS */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _createCommentVNode(" 提示信息 "),
                                    (__props.hint)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "hint-icon" }, "💡", -1 /* CACHED */)),
                                            _createElementVNode("span", null, _toDisplayString(__props.hint), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createCommentVNode(" 装饰元素 "),
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                                        return _createElementVNode("div", {
                                            key: i,
                                            class: "decoration-particle",
                                            style: _normalizeStyle(getParticleStyle(i))
                                        }, null, 4 /* STYLE */);
                                    }), 64 /* STABLE_FRAGMENT */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
